import {
  anchorStyles,
  h5Styles,
  h6Styles,
  paraStyles,
} from 'components/elements/Text'
import { globalCss } from './stitches.config'
import {
  AutoplayButtonWrap,
  BoxPageWrap,
  ButtonTransparent,
  DescriptionContainer,
  DropdownWrap,
  IconContainer,
  LinkItem,
  List,
  ReportHeader,
  ReportLink,
  scrollBar,
  SecondaryIcon,
  TitleList,
  ToggleButtonWrap,
  UnorderList,
  ValueContainer,
  VideoFooter,
} from './globalStyleCss'
import { SvgWrap } from 'components/svg'
import { ButtonCss, TagCss } from 'components/elements'
import { TabWrap } from 'components/tab'
import { SwiperWrap } from 'components/swiper'

export const globalStyles = globalCss({
  'html': {
    'fontSize': '15px',
    'boxSizing': 'border-box',
    'colorScheme': 'dark',
    '@media(min-width: 600px)': {
      fontSize: '16px',
    },
  },
  '*, *:before, *:after': {
    boxSizing: 'inherit',
  },
  'body': {
    ...scrollBar,
    fontFamily: '$Inter',
    backgroundColor: '$whiteBase',
    color: '$text',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility',
    overflowX: 'hidden',
    margin: 0,
  },
  '.inspeqLogo': {
    width: '100%',
    maxWidth: 400,
  },
  'input': {
    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus': {
      'borderColor': '$inputBorderFocus',
      '-webkit-text-fill-color': '#101828',
      '-webkit-box-shadow': '0 0 0px 1000px #F9FAFB inset',
      'transition': 'background-color 5000s ease-in-out 0s',
      'borderRadius': '$radii$sm',
    },
  },
  '.pac': {
    '&-container': {
      ...DropdownWrap,
      'span:last-child:not(.pac-matched)': {
        ...paraStyles,
      },
      '.pac-matched': {
        fontWeight: '$medium',
        color: '$primaryBase',
      },
      '&:after': {
        display: 'none',
      },
    },
    '&-item': {
      'display': 'flex',
      'alignItems': 'flex-start',
      'p': '$space$10 $space$14',
      'mb': '$space$2',
      'cursor': 'pointer',
      'border': 0,
      '&-query': {
        ...h6Styles,
      },
    },
    '&-icon-marker': {
      background: 'url("./assets/icons/markerPin.svg") center center no-repeat',
      width: 20,
      m: '0 $space$8 0 0',
    },
  },
  'video': {
    maxWidth: '100%',
  },
  'a': {
    ...anchorStyles,
  },
  '.MuiTouchRipple': {
    '&-root': {
      'span.MuiTouchRipple-child': {
        backgroundColor: '$gray100',
      },
    },
  },
  'svg': {
    path: {
      transition:
        'stroke .6s $transition$easeOutQuint, fill .6s $transition$easeOutQuint',
    },
  },
  '.errorField': {
    fontSize: '$14',
    lineHeight: '$lineHeight$20',
    marginTop: '$10 !important',
  },
  '.hasImageError, .noImage': {
    '& ~ div': {
      'background': 'transparent',
      'h6, h5, p': {
        color: '$blackBase',
      },
    },
  },
  '.map-container': {
    height: '100%',
    width: '100%',
  },
  '.sigCanvas': {
    width: '100%',
    height: '100%',
  },
  '.MuiTooltip-popper': {
    '.MuiTooltip-tooltip': {
      backgroundColor: '$gray600',
      padding: '$8 $12',
      borderRadius: '8px',
    },
    '.MuiTooltip-arrow': {
      color: '$gray600',
    },
  },
  '.audio-player': {
    '&.rhap': {
      '&_container': {
        boxShadow: 'none',
        p: '$space$10',
        border: '1px solid $border',
        borderRadius: '$radii$sm',
      },
    },
    '.rhap': {
      '&_time': {
        ...h5Styles,
      },
      '&_controls-section': {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        alignItems: 'center',
        button: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      '&_additional-controls': {
        justifySelf: 'start',
      },
      '&_volume': {
        '&-controls': {
          'display': 'none',
          'flexBasis': 60,
          '@media(min-width: 600px)': {
            display: 'flex',
          },
        },
        '&-container': {
          maxWidth: 100,
          pr: '$space$5',
        },
      },
      '&_main-controls': { pr: '$space$10' },
      '&_progress-container': {},
      '&_progress-filled': {
        background: '$primaryBase',
      },
      '&_download-progress, &_volume-bar': {
        background: '$sliderBg',
      },
      '&_progress-indicator, &_volume-indicator': {
        background: '$whiteBase',
        border: '2px solid $primaryBase',
      },
      '&_total-time': {
        ...h5Styles,
      },
    },
  },
  '.hide-report': {
    [`${ReportLink}`]: {
      display: 'none',
    },
  },
  '.fused': {
    'h1, h2, h3, h4, h5, h6, p, span, a': {
      // fontFamily: 'roboto',
    },
    'h4': {
      ...h6Styles,
      fontWeight: '$bold',
      lineHeight: '$space$22',
      color: '$blackBase',
    },
    '& p': {
      ...h6Styles,
      lineHeight: '$space$22',
      color: '#545454',
    },
    '.MuiRating-icon': {
      svg: {
        fill: '$blackBase',
      },
    },
    [`${VideoFooter}, footer`]: {
      display: 'none',
    },
    'background': '$whiteBase',
    [`${ButtonCss}`]: {
      p: '$space$9 $space$24',
      background: '#403E2A',
      borderColor: '#403E2A',
      borderRadius: '$xxs',
      fontWeight: '$normal',
    },
    [`${TabWrap}`]: {
      '&.MuiButtonBase-root': {
        ...h5Styles,
        p: '$space$10',
        pb: '$space$16',
        textTransform: 'uppercase',
        fontWeight: '$medium',
        color: '#545454',
        m: 0,
      },
      '&:not(:last-child):after': {
        content: '',
        display: 'block',
        position: 'absolute',
        right: 0,
        height: '$space$20',
        width: 1,
        background: '#403E2A',
      },
      '&.Mui-selected': {
        color: '#403E2A',
      },
    },
    '.MuiTabs-indicator': {
      backgroundColor: '#403E2A',
    },
    [`${LinkItem}`]: {
      ...h5Styles,
      color: '#545454',
    },
    [`${ToggleButtonWrap}, ${AutoplayButtonWrap}`]: {
      color: '$blackBase',
      borderColor: '$blackBase',
      backgroundColor: '$whiteBase',
    },
    [`${ButtonTransparent}`]: {
      '&.transparent': {
        p: 0,
        border: 0,
        backgroundColor: 'transparent',
        [`${SvgWrap}`]: {},
      },
    },
    [`${DescriptionContainer}`]: {
      '@media(min-width: 350px)': {
        maxWidth: `calc(100% - 200px)`,
      },
      'flexGrow': 1,
      [`${IconContainer}`]: {
        justifyContent: 'flex-end',
        [`${ButtonCss}`]: {
          mr: '$space$20',
        },
      },
    },
    [`${TitleList}`]: {
      p: 0,
      m: '0 0 $space$40',
      [`${SvgWrap}`]: {
        display: 'none',
      },
      h4: {
        fontFamily: 'Barlow Condensed',
        fontSize: '$32',
        lineHeight: '$lineHeight$40',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        ml: 0,
      },
    },
    [`${ReportHeader}`]: {
      'display': 'none',
      '@media(min-width: 200px)': {
        flexDirection: 'column',
      },
    },
    [`${TagCss}`]: {
      ...h6Styles,
      lineHeight: '$space$22',
      maxHeight: 'none',
      p: '$space$8',
      border: 0,
      borderRadius: '$xs',
      color: '$blackBase',
      background: '#F5F5F5',
    },
    [`${List}`]: {
      'background': '$whiteBase',
      'p': '$space$8 0',
      'borderBottom': '1px solid $border',
      '&:nth-child(even)': {
        background: '$whiteBase',
      },
      [`${SecondaryIcon}`]: {
        justifyContent: 'flex-end',
        [`${ButtonCss}`]: {
          mr: '$space$20',
        },
      },
      [`${ValueContainer}`]: {
        h4: {
          fontWeight: '$normal',
        },
        [`${ButtonCss}`]: {
          mr: '$space$20',
        },
      },
      [`${ButtonCss}`]: {
        p: 0,
        border: 0,
        background: 'transparent',
        svg: {
          width: 24,
          height: 24,
          path: {
            stroke: '$blackBase',
          },
        },
      },
    },
    [`${BoxPageWrap}`]: {
      p: 0,
      m: 0,
      borderRadius: 0,
      maxWidth: '100%',
    },
    [`${BoxPageWrap}.main-report`]: {
      [`${SwiperWrap}, .mainSwiper`]: {
        display: 'none',
      },
      '& > ul:first-of-type > li:first-of-type': {
        display: 'none',
      },
      '& > ul:last-of-type': {
        mb: 0,
      },
    },
    '.swiper-thumbs': {
      span: {
        fontSize: '$10',
        lineHeight: '$lineHeight$18',
        p: '$space$5',
        maxHeight: 28,
      },
    },
    [`${UnorderList}`]: {
      mb: '$space$40',
      [`${List}`]: {
        '@media(min-width: 350px)': {
          flexDirection: 'row',
          alignItems: 'baseline',
        },
        '& > h4': {
          '@media(min-width: 350px)': {
            flex: '0 0 200px',
          },
        },
      },
    },
    '.rhap': {
      '&_volume-controls': {
        '@media(min-width: 350px)': {
          display: 'block',
        },
      },
    },
  },
})

globalStyles()
